<template>
  <div class="w-full h-full">
    <div
      v-if="label && view_by?.length != 1"
      id="actionsTable"
      class="w-full p-4 h-[50px] bg-white rounded-b-none translate-x-[0.2px] dark:bg-dark-box-background dark:text-white text-xl font-medium flex justify-between rounded-md">
      <div class="cursor-default has-tooltip">
        {{ label }}<span v-if="$route.name !== 'WorkspaceItem'" class="text-common-grey" />
        <span
          class="absolute top-0 left-0 z-50 inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
          {{ $t("For") }}:
          {{
            tied_record
              ? connectTo == "this_record"
                ? `
          ${record_not_found ? $t("Not found") : tied_record_name}`
                : `${record_not_found ? $t("Record not found") : tied_record_name}`
              : record_not_found
                ? $t("Record not found")
                : $t("All Records")
          }}
        </span>
      </div>

      <div
        v-if="itemLayoutWidth < 6 && !record_not_found"
        class="flex items-center justify-center mt-4 -mr-2 translate-y-[-8px] translate-x-[-7px]">
        <Switch
          v-if="selected_tab == 'Interactions' && integrated_services.includes('outlook')"
          v-model="show_nylas_items_outlook"
          :class="[
            show_nylas_items_outlook ? 'bg-blue' : 'bg-gray-200',
            'ml-1 relative inline-flex flex-shrink-0 h-7 w-12 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue'
          ]">
          <span
            aria-hidden="true"
            :class="[
              show_nylas_items_outlook && $store.state.portfolio.ui_options?.language == 'ar'
                ? '-translate-x-5'
                : show_nylas_items_outlook
                  ? 'translate-x-5'
                  : 'translate-x-0',
              'pointer-events-none inline-block h-6 w-6 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
            ]">
            <MicrosoftIcon class="w-6 h-6 p-1" />
          </span>
        </Switch>
        <Switch
          v-if="selected_tab == 'Interactions' && integrated_services.includes('gmail')"
          v-model="show_nylas_items_gmail"
          :class="[
            show_nylas_items_gmail ? 'bg-blue' : 'bg-gray-200',
            'rtl relative inline-flex flex-shrink-0 h-7 w-12 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue'
          ]">
          <span
            aria-hidden="true"
            :class="[
              show_nylas_items_gmail && $store.state.portfolio.ui_options?.language == 'ar'
                ? '-translate-x-5'
                : show_nylas_items_gmail
                  ? 'translate-x-5'
                  : 'translate-x-0',
              'pointer-events-none inline-block h-6 w-6 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
            ]">
            <GoogleIcon class="w-6 h-6 p-1" />
          </span>
        </Switch>
        <Switch
          v-if="selected_tab == 'Interactions' && !integrated_services.includes('gmail') && !integrated_services.includes('outlook')"
          v-model="show_nylas_items_gmail"
          :class="[
            show_nylas_items_gmail ? 'bg-blue' : 'bg-gray-200',
            'relative inline-flex flex-shrink-0 h-7 w-12 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue'
          ]">
          <span
            aria-hidden="true"
            :class="[
              show_nylas_items_gmail && $store.state.portfolio.ui_options?.language == 'ar'
                ? '-translate-x-5'
                : show_nylas_items_gmail
                  ? 'translate-x-5'
                  : 'translate-x-0',
              'pointer-events-none inline-block h-6 w-6 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
            ]">
            <Mail class="w-6 h-6 p-1" />
          </span>
        </Switch>
        <button v-if="$utils.isEmpty(initialFilter)" class="btn primary-btn" @click="handleClickFilter">
          <Funnel class="w-5 h-5 text-white" />
        </button>
        <div
          v-if="selected_tab == 'Goals' && goals?.results?.length"
          :class="[{ '!bg-gray-200 has-tooltip': editing_disabled }]"
          class="flex ml-1 font-normal cursor-pointer items-center border-transparent primary-btn px-2 text-white dark:bg-dark-brand-blue rounded border-solid border-[1px] w-fit-content h-[35px] content-center text-[14px]"
          @click="editing_disabled ? null : createNewGoal()">
          <Plus class="w-5 h-5" />
          <span v-if="editing_disabled"
                class="flex-wrap p-2 bg-gray-300 rounded tooltip whitespace-nowrap mt-7">{{ $t("You don't have access to this feature") }}
          </span>
        </div>

        <div
          v-if="selected_tab == 'Tasks' && tasks?.results?.length"
          :class="[{ '!bg-gray-200 has-tooltip': editing_disabled }]"
          class="font-normal cursor-pointer items-center border-transparent primary-btn px-2 text-white dark:bg-dark-brand-blue rounded border-solid border-[1px] w-fit-content h-[35px] content-center text-[14px]"
          @click="editing_disabled ? null : createNewTask()">
          <Plus class="w-5 h-5" />
          <span v-if="editing_disabled"
                class="flex-wrap p-2 bg-gray-300 rounded tooltip whitespace-nowrap mt-7">{{ $t("You don't have access to this feature") }}
          </span>
        </div>

        <div
          v-if="selected_tab == 'Interactions' && interactions?.results?.length"
          :class="[{ '!bg-gray-200 has-tooltip': editing_disabled }]"
          class="flex ml-1 font-normal cursor-pointer items-center border-transparent primary-btn px-2 text-white dark:bg-dark-brand-blue rounded border-solid border-[1px] w-fit-content h-[35px] content-center text-[14px]"
          @click="editing_disabled ? null : createNewInteraction()">
          <Plus class="w-5 h-5" />
          <span v-if="editing_disabled"
                class="flex-wrap p-2 bg-gray-300 rounded tooltip whitespace-nowrap mt-7">{{ $t("You don't have access to this feature") }}
          </span>
        </div>

        <div
          v-if="selected_tab == 'Plans' && plans?.results?.length"
          :class="[{ '!bg-gray-200 has-tooltip': editing_disabled }]"
          class="flex ml-1 font-normal cursor-pointer items-center border-transparent primary-btn px-2 text-white dark:bg-dark-brand-blue rounded border-solid border-[1px] w-fit-content h-[35px] content-center text-[14px]"
          @click="editing_disabled ? null : createNewPlan()">
          <Plus class="w-5 h-5 mx-2" />
          <span v-if="editing_disabled"
                class="flex-wrap p-2 bg-gray-300 rounded tooltip whitespace-nowrap mt-7">{{ $t("You don't have access to this feature") }}
          </span>
        </div>
      </div>
    </div>
    <!-- Tab Buttons positioned with translate-y into the tab -->
    <div
      v-if="!record_not_found"
      class="w-full h-[70px] bg-white rounded-b-none translate-x-[0.2px] dark:bg-dark-box-background dark:text-white flex justify-between"
      :class="[label && view_by?.length != 1 ? '' : 'rounded-md']">
      <!-- absolute divider between Tab Change Buttons and actual table -->

      <div class="absolute top-[60px] bg-transparent h-[1px] dark:bg-dark-divider-border bg-light-divider-border !w-[100%]" />

      <!-- absolute divider between Tab Change Buttons and actual table -->

      <div v-if="!view_by" class="flex px-4 py-2 mt-2 rounded-md rounded-b-none">
        <div
          class="relative pr-4"
          :class="
            selected_tab != 'Plans' &&
              'transition-all duration-300 scale-1 h-[45px] border-transparent cursor-pointer hover:border-b-common-grey border-b-[2px]'
          "
          @click="changeTab('Plans')">
          <div class="flex items-center">
            <List
              :active="selected_tab == 'Plans'"
              :color="selected_tab == 'Plans' ? $store.state.ui_options.theme.selected_item_color : '#899399'"
              :dark-mode="$store.state.ui.darkMode" />
            <span
              :style="{
                color:
                  selected_tab == 'Plans' && $store.state.ui_options?.theme
                    ? `${$store.state.ui_options.theme.selected_item_color} !important`
                    : ''
              }"
              :class="selected_tab == 'Plans' && 'transition-all duration-500'"
              class="pl-2 text-common-grey">{{ $t("Plans") }}</span>
          </div>
          <div
            :style="{ backgroundColor: $store.state.ui_options?.theme ? $store.state.ui_options.theme.selected_item_color : 'bg-blue' }"
            :class="selected_tab == 'Plans' ? '!scale-100 transition-all duration-500' : ''"
            class="absolute top-[43px] w-[97%] h-[2px] scale-0 !z-1" />
        </div>
        <div
          class="relative pr-4"
          :class="
            selected_tab != 'Goals' &&
              ' transition-all duration-300 scale-1 h-[45px] border-transparent  cursor-pointer  hover:border-b-common-grey border-b-[2px] '
          "
          @click="changeTab('Goals')">
          <div class="flex items-center">
            <Star
              :active="selected_tab == 'Goals'"
              :color="selected_tab == 'Goals' ? $store.state.ui_options.theme.selected_item_color : '#899399'"
              :dark-mode="$store.state.ui.darkMode" />
            <span
              :style="{
                color:
                  selected_tab == 'Goals' && $store.state.ui_options?.theme
                    ? `${$store.state.ui_options.theme.selected_item_color} !important`
                    : ''
              }"
              :class="selected_tab == 'Goals' && 'transition-all duration-500'"
              class="pl-2 text-common-grey">{{ $t("Goals") }}</span>
          </div>
          <div
            :style="{ backgroundColor: $store.state.ui_options?.theme ? $store.state.ui_options.theme.selected_item_color : 'bg-blue' }"
            :class="selected_tab == 'Goals' ? '!scale-100 transition-all duration-500' : ''"
            class="absolute top-[43px] w-[97%] h-[2px] scale-0 !z-1" />
        </div>
        <div
          class="relative pr-4"
          :class="
            selected_tab != 'Tasks' &&
              'transition-all duration-300 scale-1 h-[45px] border-transparent  cursor-pointer  hover:border-b-common-grey border-b-[2px]'
          "
          @click="changeTab('Tasks')">
          <div class="flex items-center">
            <ClipboardCheck
              :active="selected_tab == 'Tasks'"
              :color="selected_tab == 'Tasks' ? $store.state.ui_options.theme.selected_item_color : '#899399'"
              :dark-mode="$store.state.ui.darkMode" />
            <span
              :style="{
                color:
                  selected_tab == 'Tasks' && $store.state.ui_options?.theme
                    ? `${$store.state.ui_options.theme.selected_item_color} !important`
                    : ''
              }"
              :class="selected_tab == 'Tasks' && 'transition-all duration-500'"
              class="pl-2 text-common-grey">{{ $t("Tasks") }}</span>
          </div>
          <div
            :style="{ backgroundColor: $store.state.ui_options?.theme ? $store.state.ui_options.theme.selected_item_color : 'bg-blue' }"
            :class="selected_tab == 'Tasks' ? '!scale-100 transition-all duration-500' : ''"
            class="absolute top-[43px] w-[97%] h-[2px] scale-0 !z-1" />
        </div>
        <div
          class="relative pr-4"
          :class="
            selected_tab != 'Interactions' &&
              'transition-all duration-300 scale-1 h-[45px] border-transparent   cursor-pointer hover:border-b-common-grey border-b-[2px]'
          "
          @click="changeTab('Interactions')">
          <div class="flex items-center">
            <ArrowLeftRight
              :active="selected_tab == 'Interactions'"
              :color="selected_tab == 'Interactions' ? $store.state.ui_options.theme.selected_item_color : '#899399'"
              :dark-mode="$store.state.ui.darkMode" />
            <span
              :style="{
                color:
                  selected_tab == 'Interactions' && $store.state.ui_options?.theme
                    ? `${$store.state.ui_options.theme.selected_item_color} !important`
                    : ''
              }"
              :class="selected_tab == 'Interactions' && 'transition-all duration-500'"
              class="pl-2 text-common-grey">{{ $t("Interactions") }}</span>
          </div>
          <div
            :style="{ backgroundColor: $store.state.ui_options?.theme ? $store.state.ui_options.theme.selected_item_color : 'bg-blue' }"
            :class="selected_tab == 'Interactions' ? '!scale-100 transition-all duration-500' : ''"
            class="absolute top-[43px] w-[97%] h-[2px] scale-0 !z-1" />
        </div>
      </div>
      <div v-else-if="view_by && view_by.length != 1" class="flex w-full px-4 py-2 mt-2 rounded-md rounded-b-none">
        <div
          v-if="view_by.includes('plans')"
          class="relative pr-4"
          :class="
            selected_tab != 'Plans' &&
              'transition-all duration-300 scale-1 h-[45px] border-transparent   cursor-pointer hover:border-b-common-grey border-b-[2px]'
          "
          @click="changeTab('Plans')">
          <div class="flex items-center">
            <List
              :active="selected_tab == 'Plans'"
              :color="selected_tab == 'Plans' ? $store.state.ui_options.theme.selected_item_color : '#899399'"
              :dark-mode="$store.state.ui.darkMode" />
            <span
              :style="{
                color:
                  selected_tab == 'Plans' && $store.state.ui_options?.theme
                    ? `${$store.state.ui_options.theme.selected_item_color} !important`
                    : ''
              }"
              :class="selected_tab == 'Plans' && 'transition-all duration-500'"
              class="pl-2 text-common-grey">{{ $t("Plans") }}</span>
          </div>
          <div
            :style="{ backgroundColor: $store.state.ui_options?.theme ? $store.state.ui_options.theme.selected_item_color : 'bg-blue' }"
            :class="selected_tab == 'Plans' ? '!scale-100 transition-all duration-500' : ''"
            class="absolute top-[43px] w-[97%] h-[2px] scale-0 !z-1" />
        </div>
        <div
          v-if="view_by.includes('goals')"
          class="relative pr-4"
          :class="
            selected_tab != 'Goals' &&
              ' transition-all duration-300 scale-1 h-[45px] border-transparent  cursor-pointer  hover:border-b-common-grey border-b-[2px] '
          "
          @click="changeTab('Goals')">
          <div class="flex items-center">
            <Star
              :active="selected_tab == 'Goals'"
              :color="selected_tab == 'Goals' ? $store.state.ui_options.theme.selected_item_color : '#899399'"
              :dark-mode="$store.state.ui.darkMode" />
            <span
              :style="{
                color:
                  selected_tab == 'Goals' && $store.state.ui_options?.theme
                    ? `${$store.state.ui_options.theme.selected_item_color} !important`
                    : ''
              }"
              :class="selected_tab == 'Goals' && 'transition-all duration-500'"
              class="pl-2 text-common-grey">{{ $t("Goals") }}</span>
          </div>
          <div
            :style="{ backgroundColor: $store.state.ui_options?.theme ? $store.state.ui_options.theme.selected_item_color : 'bg-blue' }"
            :class="selected_tab == 'Goals' ? '!scale-100 transition-all duration-500' : ''"
            class="absolute top-[43px] w-[97%] h-[2px] scale-0 !z-1" />
        </div>
        <div
          v-if="view_by.includes('tasks')"
          class="relative pr-4"
          :class="
            selected_tab != 'Tasks' &&
              'transition-all duration-300 scale-1 h-[45px] border-transparent  cursor-pointer  hover:border-b-common-grey border-b-[2px]'
          "
          @click="changeTab('Tasks')">
          <div class="flex items-center">
            <ClipboardCheck
              :active="selected_tab == 'Tasks'"
              :color="selected_tab == 'Tasks' ? $store.state.ui_options.theme.selected_item_color : '#899399'"
              :dark-mode="$store.state.ui.darkMode" />
            <span
              :style="{
                color:
                  selected_tab == 'Tasks' && $store.state.ui_options?.theme
                    ? `${$store.state.ui_options.theme.selected_item_color} !important`
                    : ''
              }"
              :class="selected_tab == 'Tasks' && 'transition-all duration-500'"
              class="pl-2 text-common-grey">{{ $t("Tasks") }}</span>
          </div>
          <div
            :style="{ backgroundColor: $store.state.ui_options?.theme ? $store.state.ui_options.theme.selected_item_color : 'bg-blue' }"
            :class="selected_tab == 'Tasks' ? '!scale-100 transition-all duration-500' : ''"
            class="absolute top-[43px] w-[97%] h-[2px] scale-0 !z-1" />
        </div>
        <div
          v-if="view_by.includes('interactions')"
          class="relative pr-4"
          :class="
            selected_tab != 'Interactions' &&
              'transition-all duration-300 scale-1 h-[45px] border-transparent   cursor-pointer hover:border-b-common-grey border-b-[2px]'
          "
          @click="changeTab('Interactions')">
          <div class="flex items-center">
            <ArrowLeftRight
              :active="selected_tab == 'Interactions'"
              :color="selected_tab == 'Interactions' ? $store.state.ui_options.theme.selected_item_color : '#899399'"
              :dark-mode="$store.state.ui.darkMode" />
            <span
              :style="{
                color:
                  selected_tab == 'Interactions' && $store.state.ui_options?.theme
                    ? `${$store.state.ui_options.theme.selected_item_color} !important`
                    : ''
              }"
              :class="selected_tab == 'Interactions' && 'transition-all duration-500'"
              class="pl-2 text-common-grey">{{ $t("Interactions") }}</span>
          </div>
          <div
            :style="{ backgroundColor: $store.state.ui_options?.theme ? $store.state.ui_options.theme.selected_item_color : 'bg-blue' }"
            :class="selected_tab == 'Interactions' ? '!scale-100 transition-all duration-500' : ''"
            class="absolute top-[43px] w-[97%] h-[2px] scale-0 !z-1" />
        </div>
      </div>
      <div v-else-if="view_by.length == 1" class="flex w-full px-4 py-2 mt-2 font-bold rounded-md rounded-b-none dark:text-white">
        {{ label }}
      </div>

      <div v-if="itemLayoutWidth >= 6" class="flex items-center justify-center mt-4 translate-y-[-8px] translate-x-[-7px]">
        <Switch
          v-if="selected_tab == 'Interactions' && integrated_services.includes('outlook')"
          v-model="show_nylas_items_outlook"
          :class="[
            show_nylas_items_outlook ? 'bg-blue' : 'bg-gray-200',
            'ml-1 relative inline-flex flex-shrink-0 h-7 w-12 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue'
          ]">
          <span
            aria-hidden="true"
            :class="[
              show_nylas_items_outlook && $store.state.portfolio.ui_options?.language == 'ar'
                ? '-translate-x-5'
                : show_nylas_items_outlook
                  ? 'translate-x-5'
                  : 'translate-x-0',
              'pointer-events-none inline-block h-6 w-6 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
            ]">
            <MicrosoftIcon class="w-6 h-6 p-1" />
          </span>
        </Switch>
        <Switch
          v-if="selected_tab == 'Interactions' && integrated_services.includes('gmail')"
          v-model="show_nylas_items_gmail"
          :class="[
            show_nylas_items_gmail ? 'bg-blue' : 'bg-gray-200',
            'mr-2 relative inline-flex flex-shrink-0 h-7 w-12 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue'
          ]">
          <span
            aria-hidden="true"
            :class="[
              show_nylas_items_gmail && $store.state.portfolio.ui_options?.language == 'ar'
                ? '-translate-x-5'
                : show_nylas_items_gmail
                  ? 'translate-x-5'
                  : 'translate-x-0',
              'pointer-events-none inline-block h-6 w-6 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
            ]">
            <GoogleIcon class="w-6 h-6 p-1" />
          </span>
        </Switch>
        <Switch
          v-if="selected_tab == 'Interactions' && !integrated_services.includes('gmail') && !integrated_services.includes('outlook')"
          v-model="show_nylas_items_gmail"
          :class="[
            show_nylas_items_gmail ? 'bg-blue' : 'bg-gray-200',
            'mr-2 relative inline-flex flex-shrink-0 h-7 w-12 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue'
          ]">
          <span
            aria-hidden="true"
            :class="[
              show_nylas_items_gmail && $store.state.portfolio.ui_options?.language == 'ar'
                ? '-translate-x-5'
                : show_nylas_items_gmail
                  ? 'translate-x-5'
                  : 'translate-x-0',
              'pointer-events-none inline-block h-6 w-6 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
            ]">
            <Mail :class="[show_nylas_items_gmail ? 'text-blue' : 'text-common-grey']" class="w-6 h-6 p-1" />
          </span>
        </Switch>

        <SelectInput
          v-show="false"
          :value="period"
          :icon="user_menu_icon"
          :is-box-background="true"
          label-attr="label"
          value-attr="value"
          class="relative w-[170px] h-[36px] mr-2"
          input-classes="h-[36px] text-left rounded-md"
          name="period"
          :placeholder="$t('Select Period')"
          :allow-null="false"
          :items="relative_dates"
          @update:currentItem="period = $event" />
        <div
          v-if="selected_tab != 'Interactions' && itemLayoutWidth >= 8 && $utils.isEmpty(initialFilter)"
          class="relative min-w-[200px] w-[300px] h-[36px] mr-1 -mt-2">
          <div class="absolute inset-y-0 flex items-center pointer-events-none left-2 top-2">
            <Search class="z-10 w-5 h-5 text-gray-400" aria-hidden="true" />
          </div>
          <TextInput
            :in-table-filter="true"
            :icon="true"
            input-classes="appearance-none block px-3 py-1 h-[36px] placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
            :name="selected_tab == 'Plans' ? 'plan_name' : selected_tab == 'Goals' ? 'goal_name' : 'task_name'"
            type="text"
            class=""
            :validate-on-input="true"
            :placeholder="$t('Search in Activities Table')"
            :value="selected_tab == 'Plans' ? plans_search_term : selected_tab == 'Goals' ? goals_search_term : tasks_search_term"
            :debounce="500"
            @update:modelValue="
              (e) => {
                selected_tab == 'Plans'
                  ? (plans_search_term = e)
                  : selected_tab == 'Goals'
                    ? (goals_search_term = e)
                    : (tasks_search_term = e)
              }
            " />
        </div>
        <div
          v-if="selected_tab == 'Goals'"
          class="flex ml-1 font-normal cursor-pointer items-center border-transparent primary-btn px-2 text-white dark:bg-dark-brand-blue rounded border-solid border-[1px] w-fit-content mr-[4px] h-[36px] content-center text-[14px]"
          :class="[{ '!bg-gray-200 has-tooltip': editing_disabled }]"
          @click="editing_disabled ? null : createNewGoal()">
          <Plus class="w-5 h-5 ml-1" />
          <div class="whitespace-nowrap pl-1 min-w-[90px]">
            {{ $t("Create Goal") }}
          </div>
          <span v-if="editing_disabled"
                class="flex-wrap p-2 bg-gray-300 rounded tooltip whitespace-nowrap mt-7">{{ $t("You don't have access to this feature") }}
          </span>
        </div>

        <div
          v-if="selected_tab == 'Tasks'"
          :class="[{ '!bg-gray-200 has-tooltip': editing_disabled }]"
          class="flex ml-1 font-normal has-tooltip cursor-pointer items-center border-transparent primary-btn px-2 text-white dark:bg-dark-brand-blue rounded border-solid border-[1px] w-fit-content mr-[4px] h-[36px] content-center text-[14px]"
          @click="editing_disabled ? null : createNewTask()">
          <Plus class="w-5 h-5 ml-1" />
          <div class="whitespace-nowrap pl-1 min-w-[90px]">
            {{ $t("Create Task") }}
          </div>
          <span v-if="editing_disabled"
                class="flex-wrap p-2 bg-gray-300 rounded tooltip whitespace-nowrap mt-7">{{ $t("You don't have access to this feature") }}
          </span>
        </div>

        <div
          v-if="selected_tab == 'Interactions'"
          :class="[{ '!bg-gray-200 has-tooltip': editing_disabled }]"
          class="flex ml-1 font-normal cursor-pointer items-center border-transparent primary-btn px-2 text-white dark:bg-dark-brand-blue rounded border-solid border-[1px] w-fit-content mr-[4px] h-[36px] content-center text-[14px]"
          @click="editing_disabled ? null : createNewInteraction()">
          <Plus class="w-5 h-5 ml-1" />
          <div class="whitespace-nowrap pl-1 min-w-[90px]">
            {{ $t("Create Interaction") }}
          </div>
          <span v-if="editing_disabled"
                class="flex-wrap p-2 bg-gray-300 rounded tooltip whitespace-nowrap mt-7">{{ $t("You don't have access to this feature") }}
          </span>
        </div>

        <div
          v-if="selected_tab == 'Plans'"
          :class="[{ '!bg-gray-200 has-tooltip': editing_disabled }]"
          class="flex ml-1 font-normal cursor-pointer items-center border-transparent primary-btn px-2 text-white dark:bg-dark-brand-blue rounded border-solid border-[1px] w-fit w-fit-content mr-[4px] h-[36px] content-center text-[14px]"
          @click="editing_disabled ? null : createNewPlan()">
          <Plus class="w-5 h-5 ml-1" />
          <span v-if="editing_disabled"
                class="flex-wrap p-2 bg-gray-300 rounded tooltip whitespace-nowrap mt-7">{{ $t("You don't have access to this feature") }}
          </span>

          <div class="whitespace-nowrap pl-1">
            {{ $t("Create Plan") }}
          </div>
        </div>
        <div
          v-if="!editing_disabled"
          class="w-[36px] h-[36px] ml-1 border hover:cursor-pointer bg-white hover:bg-gray-100 shadow-none dark:bg-dark-screen-background inline-flex flex-shrink-0 items-center justify-center text-gray-400 rounded border-light-divider-border dark:border-dark-divider-border transition ease-in-out duration-side-menu-transition-duration"
          @click.passive="
            $emitter.emit(ALL_EMITTERS.UPDATE_ACTIVITIES_TABLE_HEADERS, {
              component_reference: componentReference,
              type: selected_tab
            })
          ">
          <Grid2x2Plus class="w-5 h-5 text-gray-500" aria-hidden="true" />
        </div>
      </div>
    </div>

    <div v-if="!record_not_found" class="relative h-[calc(100%-120px)] bg-white">
      <transition
        duration="100"
        mode="out-in"
        enter-active-class="animate__animated animate__fadeIn "
        leave-active-class="animate__animated animate__slideFadeOut">
        <div v-if="selected_tab == 'Plans'" class="relative h-full bg-white rounded-md rounded-t-none dark:bg-dark-box-background">
          <PlansComponent
            :connect-to="connectTo"
            :linked-record="linkedRecord"
            :component-reference="componentReference"
            :current-template="currentTemplate"
            :current-company="currentCompany"
            :initial-filter="initialFilter"
            :plans-search-term="plans_search_term"
            :preserved-page-size="preservedPageSize"
            @preservedFilters="updatePage($event)" />
        </div>

        <div v-else-if="selected_tab == 'Goals'" class="relative h-full bg-white dark:bg-dark-box-background">
          <GoalsComponent
            :connect-to="connectTo"
            :linked-record="linkedRecord"
            :component-reference="componentReference"
            :current-template="currentTemplate"
            :current-company="currentCompany"
            :initial-filter="initialFilter"
            :goals-search-term="goals_search_term"
            :preserved-page-size="preservedPageSize"
            @preservedFilters="updatePage($event)" />
        </div>

        <div v-else-if="selected_tab == 'Tasks'" class="relative h-full bg-white dark:bg-dark-box-background">
          <TasksComponent
            :connect-to="connectTo"
            :linked-record="linkedRecord"
            :component-reference="componentReference"
            :current-template="currentTemplate"
            :current-company="currentCompany"
            :initial-filter="initialFilter"
            :tasks-search-term="tasks_search_term"
            :preserved-page-size="preservedPageSize"
            @preservedFilters="updatePage($event)" />
        </div>

        <div v-else-if="selected_tab == 'Interactions'" class="relative h-full">
          <InteractionsComponent
            :connect-to="connectTo"
            :linked-record="linkedRecord"
            :component-reference="componentReference"
            :current-template="currentTemplate"
            :current-company="currentCompany"
            :show-nylas-items-gmail="show_nylas_items_gmail"
            :show-nylas-items-outlook="show_nylas_items_outlook"
            :initial-filter="initialFilter"
            :preserved-page-size="preservedPageSize"
            @preservedFilters="updatePage($event)" />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { useLayoutItemSharedLogic } from "@/components/shared/pages/useLayoutItemSharedLogic.js"
import { Grid2x2Plus, Mail, ClipboardCheck, ArrowLeftRight, Funnel, Search, Plus, User, Star, List } from "lucide-vue-next"
import TasksComponent from "@/components/shared/activities-table/TasksComponent.vue"
import GoalsComponent from "@/components/shared/activities-table/GoalsComponent.vue"
import PlansComponent from "@/components/shared/activities-table/PlansComponent.vue"
import InteractionsComponent from "@/components/shared/activities-table/InteractionsComponent.vue"
import GoogleIcon from "@/components/shared/icons/GoogleIcon.vue"
import MicrosoftIcon from "@/components/shared/icons/MicrosoftIcon.vue"
import TextInput from "@/components/shared/TextInput.vue"
import { Record } from "@/models/record"
import SelectInput from "@/components/shared/SelectInput.vue"
import { markRaw } from "vue"
import { Switch } from "@headlessui/vue"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: {
    TasksComponent,
    GoalsComponent,
    PlansComponent,
    InteractionsComponent,
    Grid2x2Plus,
    Mail,
    SelectInput,
    List,
    Search,
    ArrowLeftRight,
    Plus,
    TextInput,
    GoogleIcon,
    MicrosoftIcon,
    ClipboardCheck: markRaw(ClipboardCheck),
    Star: markRaw(Star),
    Funnel,
    Switch
  },
  inject: ["canUserEditLayout", "updateCursorPosition"],
  props: {
    initialFilter: {
      type: Object,
      default: () => ({})
    },
    label: {
      type: String,
      default: ""
    },
    view_by: {
      type: Array,
      default: null
    },
    connectTo: {
      type: String,
      default: ""
    },
    linkedRecord: null,
    itemLayoutWidth: {
      type: Number,
      default: null
    },
    componentReference: {
      type: String,
      required: false
    },
    preservedPageSize: {
      type: Number,
      default: 5
    },
    currentTemplate: {
      type: Object,
      required: false
    },
    currentCompany: {
      type: Object,
      required: false
    }
  },
  emits: ["update:preservedFilters", "cancel"],
  data() {
    return {
      loading: false,
      record_error: false,
      component_record: null,
      relative_dates: [
        {
          label: this.$t("Today"),
          value: "today",
          start: this.$moment().startOf("day").toDate(),
          end: this.$moment().endOf("day").toDate()
        },
        {
          label: this.$t("This Week"),
          value: "this_week",
          start: this.$moment().startOf("week").toDate(),
          end: this.$moment().endOf("week").toDate()
        },
        {
          label: this.$t("This Month"),
          value: "this_month",
          start: this.$moment().startOf("month").toDate(),
          end: this.$moment().endOf("month").toDate()
        }
      ],
      period: null,
      ALL_EMITTERS,
      Record,
      user_menu_icon: User,
      selected_tab: "Plans",

      //plans
      plans: { results: [], count: 0 },
      plans_search_term: "",

      //goals
      goals: { results: [], count: 0 },
      goals_search_term: "",

      //tasks
      tasks: { results: [], count: 0 },
      tasks_search_term: "",

      //interactions
      interactions: { results: [], count: 0 },

      show_nylas_items_gmail: true,
      show_nylas_items_outlook: true,
      tied_record_name: "",
      tied_record_full: null,
      record_not_found: false
    }
  },
  computed: {
    editing_disabled() {
      let editing_disabled_calc = false

      if (this.$route.name == "WorkspaceItem" && this.$store.state.ui.workspace_user_access_scope == "read") {
        editing_disabled_calc = true
      }

      if (this.$route.name == "Dashboard" && this.$route.params.page) {
        const current_template = this.$store.state.portfolio.shared_layouts.find((l) => l.id == this.$route.params.page)
        if (!this.canUserEditLayout(this.$store.state.auth.user, current_template)) {
          editing_disabled_calc = true
        }
      }

      return editing_disabled_calc
    },
    integrated_services() {
      const services = []
      if (this.$store.state.integration.integrations.find((i) => i.name == "gmail")) {
        services.push("gmail")
      }
      if (this.$store.state.integration.integrations.find((i) => i.name == "outlook")) {
        services.push("outlook")
      }
      return services
    },
    tied_record() {
      if (this.initialFilter?.companies?.includes("this_record") || this.connectTo == "this_record") {
        return this.$route.params.cid
      } else if (this.connectTo == "another_record") {
        return this.linkedRecord
      } else {
        return null
      }
    }
  },

  watch: {
    view_by: {
      deep: true,
      handler() {
        if (!this.view_by?.includes(this.selected_tab.toLowerCase())) {
          this.setTabFromViewBy()
        }
      }
    },
    tied_record_full() {
      this.setTabFromViewBy()
    },
    connectTo() {
      this.getTiedCompany()
    },
    linkedRecord: {
      deep: true,
      handler() {
        this.getTiedCompany()
      }
    },
    currentCompany() {
      this.tied_record_full = this.currentCompany
    }
  },
  created() {
    const { loading, record_error, component_record } = useLayoutItemSharedLogic(
      this.$props,
      this.postGetComponentRecord,
      this.registerListeners,
      this.unregisterListeners
    )
    this.loading = loading
    this.record_error = record_error
    this.component_record = component_record
    this.getTiedCompany()
  },

  activated() {
    this.getTiedCompany()
  },

  methods: {
    postGetComponentRecord() {
      if (this.connectTo == "this_record" || this.initialFilter?.companies?.includes("this_record")) {
        this.tied_record_name = this.component_record?.name
        this.tied_record_full = this.component_record
        this.setTabFromViewBy()
      } else if (this.connectTo == "another_record") {
        this.$store.dispatch("data/getRecord", this.linkedRecord.id ? this.linkedRecord.id : this.linkedRecord).then(() => {
          this.tied_record_name = this.component_record?.name
          this.tied_record_full = this.component_record
          this.setTabFromViewBy()
        })
      } else {
        this.setTabFromViewBy()
      }
    },
    registerListeners() {},
    unregisterListeners() {},
    updatePage({ page_size }) {
      this.$emit("update:preservedFilters", { preservedPageSize: page_size })
    },

    getTiedCompany() {
      if (
        (this.connectTo == "this_record" || this.initialFilter?.companies?.includes("this_record")) &&
        this.$store.state.ui.currentCompany
      ) {
        this.tied_record_name = this.$store.state.ui.currentCompany?.name
        this.tied_record_full = this.$store.state.ui.currentCompany
        this.setTabFromViewBy()
      } else if (this.connectTo == "another_record") {
        this.$store.dispatch("data/getRecord", this.linkedRecord.id ? this.linkedRecord.id : this.linkedRecord).then(() => {
          this.tied_record_name = Record.from(
            this.$store.state.data.records_fetched[this.linkedRecord.id ? this.linkedRecord.id : this.linkedRecord]
          ).name
          this.tied_record_full = this.$store.state.data.records_fetched[this.linkedRecord.id ? this.linkedRecord.id : this.linkedRecord]
          this.setTabFromViewBy()
        })
      } else {
        this.setTabFromViewBy()
      }
    },
    setTabFromViewBy() {
      if (this.view_by?.includes("plans")) {
        this.selected_tab = "Plans"
      } else if (this.view_by?.includes("goals")) {
        this.selected_tab = "Goals"
      } else if (this.view_by?.includes("tasks")) {
        this.selected_tab = "Tasks"
      } else if (this.view_by?.includes("interactions")) {
        this.selected_tab = "Interactions"
      } else {
        this.selected_tab = "Plans"
      }
    },
    handleClickFilter() {
      if (this.selected_tab == "Plans") {
        this.plans_search_term = null
      } else if (this.selected_tab == "Goals") {
        this.goals_search_term = null
      } else if (this.selected_tab == "Tasks") {
        this.tasks_search_term = null
      }
    },
    createNewGoal() {
      if (!this.tied_record) {
        return this.$emitter.emit(ALL_EMITTERS.CREATE_GOAL)
      } else {
        const data = {
          record: this.tied_record_full
        }
        if (this.tied_record_full?.type !== "company" && this.tied_record_full?.type !== "opportunity") {
          if (this.tied_record_full?.parent) {
            data["record"] = this.tied_record_full?.parent
          }
          if (this.tied_record_full?.type == "contact") {
            data["contact"] = this.tied_record_full
          }
        }
        return this.$emitter.emit(ALL_EMITTERS.CREATE_GOAL, data)
      }
    },
    createNewInteraction() {
      if (!this.tied_record) {
        return this.$emitter.emit(ALL_EMITTERS.CREATE_INTERACTION)
      } else {
        const data = {
          record: this.tied_record_full
        }
        if (this.tied_record_full?.type !== "company" && this.tied_record_full?.type !== "opportunity") {
          if (this.tied_record_full?.parent) {
            data["record"] = this.tied_record_full?.parent
          }
          if (this.tied_record_full?.type == "contact") {
            data["contact"] = this.tied_record_full
          }
        }
        return this.$emitter.emit(ALL_EMITTERS.CREATE_INTERACTION, data)
      }
    },
    createNewPlan() {
      if (!this.tied_record) {
        return this.$emitter.emit(ALL_EMITTERS.CREATE_PLAN)
      } else {
        const data = {
          record: this.tied_record_full,
          contact: ""
        }
        if (this.tied_record_full?.type !== "company" && this.tied_record_full?.type !== "opportunity") {
          if (this.tied_record_full?.parent) {
            data["record"] = this.tied_record_full?.parent
          }
          if (this.tied_record_full?.type == "contact") {
            data["contact"] = this.tied_record_full
          }
        }
        return this.$emitter.emit(ALL_EMITTERS.CREATE_PLAN, data)
      }
    },
    createNewTask() {
      if (!this.tied_record) {
        this.$emitter.emit(ALL_EMITTERS.CREATE_TASK)
      } else {
        const data = {
          record: this.tied_record_full
        }
        if (this.tied_record_full?.type !== "company" && this.tied_record_full?.type !== "opportunity") {
          if (this.tied_record_full?.parent) {
            data["record"] = this.tied_record_full?.parent
          }
          if (this.tied_record_full?.type == "contact") {
            data["contact"] = this.tied_record_full
          }
        }
        return this.$emitter.emit(ALL_EMITTERS.CREATE_TASK, data)
      }
    },
    changeTab(tab) {
      this.selected_tab = tab
    }
  }
}
</script>
